import type { GQL_ID } from '@@partner:types:graphql'

import React, { useState } from 'react'
import { useFetchAllMarketingLabels } from '@@partner:graphql/query/labels/allMarketingLabels.gql'

import { Tag } from 'rsuite'
import AppLoader from '@components/common/AppLoader'

export interface LabelsSelectedItemsProps {
  items?: GQL_ID[]
  loading?: boolean
  onCategoryDrop(id: GQL_ID): void
}

export default function LabelsSelectedItems ({
  items = [],
  loading = false,
  onCategoryDrop
}: LabelsSelectedItemsProps) {
  const [ page ] = useState(1)
  const { data } = useFetchAllMarketingLabels({
    pager: { page }
  })

  const selectedLabels = data?.allMarketingLabels?.edges.filter(
    (selected: GQL_ID) => items.includes(selected.id)
  )

  if (!items) {
    return null
  }

  return (
    <div>
      {loading && <AppLoader.Inner content="Загрузка лейблов" />}

      {selectedLabels?.map((item: any) => (
        <div className="my-2" key={`SelectedLabel:${item.id}`}>
          <Tag closable onClose={() => onCategoryDrop(item.id)}>
            {item.name ? item.name : item.system_name}
          </Tag>
        </div>
      ))}
    </div>
  )
}
